// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconAssetsPath = 'M16.743 17.134c-.334.575-1.104.866-2.286.866H10v-8H5.18C6.442 7.991 8.02 7 10 7c2.11 0 3.767 1.111 5.068 3.396 1.682 2.951 2.34 5.596 1.675 6.738ZM3 18h5v-2H3v2Zm0-4h5v-2H3v2ZM7.392 2.827A4.726 4.726 0 0 1 10.006 2h.03c1.15 0 2.052.43 2.64.826L10.948 5H10c-.286 0-.565.027-.84.058L7.391 2.827Zm9.414 6.578c-.567-.996-1.224-1.818-1.95-2.482 1.177-.197 2.217-.799 3.037-1.782L16.356 3.86C15.726 4.616 14.933 5 14 5h-.497l1.904-2.395-.629-.631C14.185 1.379 12.541 0 10.038 0h-.044C7.51.015 5.878 1.386 5.292 1.974l-.628.63L7.06 5.628c-1.528.697-2.838 1.97-3.867 3.777-.103.183-.214.388-.324.595H1v10h13.457c1.946 0 3.297-.626 4.015-1.861 1.454-2.501-.419-6.545-1.666-8.734Z';
var IconAssets = baseIcon('IconAssets', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconAssetsPath
});
export default IconAssets;
//# sourceMappingURL=index.js.map